import { MetricCard } from "@/components/cards/metric-card";

type Props = { total: number; visible: number; unpublished: number };

export default function ProductSummary({ total, visible, unpublished }: Props) {
  return (
    <div className="flex! w-full! flex-col! gap-10! lg:w-[76.6667%]!">
      <header className="flex! flex-col! gap-2!">
        <h1 className="m-0! text-3xl! font-bold! text-zinc-800!">
          Meus Produtos
        </h1>
        <p className="m-0! text-[#28272c]!">
          Gerencie os produtos e serviços exibidos na sua vitrine pública.
        </p>
      </header>
      <div className="grid! grid-cols-1! gap-4! sm:grid-cols-2! xl:grid-cols-3!">
        <MetricCard
          title="Produtos cadastrados"
          value={total}
          icon="shopping_bag"
        />
        <MetricCard
          title="Visíveis na vitrine pública"
          value={visible}
          icon="add_business"
        />
        <MetricCard
          title="Ainda não publicados"
          value={unpublished}
          icon="edit_document"
        />
      </div>
    </div>
  );
}
